/*
 * ALL RIGHTS RESERVED,
 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
 */

import { AuthenticationService } from '../../common/authentication/service/AuthenticationService';
import { PjInjectProxy } from '../../common/extends_fw/PjInjectProxy';
import { PjBaseController, Alert } from '../../common/extends_fw/controller/PjBaseController';
import { PjServiceResponse } from '../../common/extends_fw/service/PjServiceResponse';
import { MsgLevel } from '../../framework/controller/MsgLevel';
import { LoginService } from '../service/LoginService';
import { AuthenticationJson } from '../json/JsonAll';
import { UserEditJson } from '../json/JsonAll';
import { SharedService } from '../../common/extends_fw/controller/PjBaseController';

/**
 * パスワード画面について出力処理およびイベント処理を行う。
 */
export class LoginController extends PjBaseController {

    // 画面情報
    public record: AuthenticationJson;

    // ユーザID
    public userId: string;

    // パスワード
    public password: string;

    // 取得ユーザ情報
    public userInfo: any;

    /**
     * コンストラクタ
     */
    /* @ngInject */
    public constructor(
            protected $stateParams: angular.ui.IStateParamsService,
            protected $window: ng.IWindowService,
            protected $uibModal: ng.ui.bootstrap.IModalService,
            protected $translate: ng.translate.ITranslateService,
            protected pjInjectProxy: PjInjectProxy,
            protected loginService: LoginService,
            protected $location: ng.ILocationService,
            protected sharedService: SharedService,
            protected $scope: any,
            protected ValidationService: any) {
        super($stateParams, $translate, $location, pjInjectProxy);
        this.setTitle('form01.title');
        this.setMenu( false );
    }

    public login(): void {
        if(!new this.ValidationService().checkFormValidity(this.$scope.loginIn)) {
            return;
        }
        let record: any = {
            userId: this.userId,
            password: this.password
        };
        this.record = record;
        this.loginService.login(this.record).then((data: any) => {
            this.userInfo = data.data.user;
            this.sharedService.set('auth',
                {role: parseInt(this.userInfo.role), userId: this.userInfo.userId, userName: this.userInfo.userName, companyId: this.userInfo.companyId, companyName: this.userInfo.companyName});
            if (this.userInfo.passwordChangeDate === null) {
                this.$location.url('/loginPassword');
            } else {
                this.$location.url('/top');
            }
        }).catch((errorData: any) => {
            this.catch(errorData);
        });
    }

    /**
     * ダイアログ表示
     */
    public show_dialog(id: string = null): void {
        let test: any = this.$uibModal.open({
            templateUrl: 'template/login/edit.html',
            controller: 'loginEditController',
            controllerAs: 'loginEdit'
        });
    }

    /**
     * 復元処理
     * @param {any} data 復元用データ
     */
    public restore(data: any): void {}

    /**
     * 表示処理
     */
    public show(): void {}
}

export class LoginEditController extends PjBaseController {

    // モーダル画面タイトル
    public modalTitle: string;

    // メールアドレス入力値
    public userId: string;

    /**
     * コンストラクタ
     */
    /* @ngInject */
    public constructor(
            protected $stateParams: angular.ui.IStateParamsService,
            protected $uibModalInstance: ng.ui.bootstrap.IModalServiceInstance,
            protected $translate: ng.translate.ITranslateService,
            protected $location: ng.ILocationService,
            protected pjInjectProxy: PjInjectProxy,
            protected loginService: LoginService,
            protected $scope: any) {
        super($stateParams, $translate, $location, pjInjectProxy);
        this.modalTitle = 'form03.title';
    }

   public passwordInit(): void {
        let query: any = {
            userId: this.userId
        };
        this.loginService.passwordInit(query).then((data: any) => {
            this.$uibModalInstance.close('passwordInit');
        }).catch((errorData: any) => {
            this.catch(errorData);
        });
    }

    /**
     * 復元処理
     * @param {any} data 復元用データ
     */
    public restore(data: any): void {}

    /**
     * 表示処理
     */
    public show(): void {}
}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/ma/controller/LoginController.ts
 **/